

















































































import { defineComponent } from '@vue/composition-api';
import { Rules } from '../../types/Rules';
import Header from '@/components/Header/Header.vue';

export default defineComponent({
  name: 'Rules',
  props: {
    rules: Object as () => Rules,
    english: Boolean,
  },
  components: {
    Header,
  },
});
